import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { LocationOwner } from './location-owner';
import { LocationOwnerSerializer } from './location-owner.serializer';
import { ResourceService } from '../shared/resource.service';
import { HttpClient } from '@angular/common/http';

export type ReferenceEditModel = {
  name: string
};

@Injectable()
export class LocationOwnerService extends ResourceService<LocationOwner> {
  baseUrl = environment.serverUrl + 'locationowners/';
  public nextUri!: string;
  public count: any;
  public search = '';
  public allSelected = false;
  progress$: any;
  progress: any;

  constructor(http: HttpClient) {
    super(http, 'locationowners/', new LocationOwnerSerializer());
  }
}
